import React from "react"
import SEO from "../components/seo"
import Community from "../components/community";
import { injectIntl } from "react-intl";
import withPageContext from "../pageContext";
import { compose } from "recompose";
import withLayout from "../layout";
import Link from "../components/LocalizedLink";
import illu from "../images/illu.svg";
import dotshape from "../images/DotShape.png";
import icon from "../images/icon.png";
import socialMediaMarketing from "../images/social-media-marketing.png";
import checkmarkCircle2 from "../images/checkmark-circle-2.png";
import IlluPersonnalAssistant from "../images/Illu personnal assistant.png";

import googleCalendar from "../images/1200px-Google_Calendar_icon.svg.png";
import office from "../images/icons8-microsoft-office-2019-50.png";
import exchange from "../images/icons8-microsoft-exchange-2019-50.png";
import gmail from "../images/gmail.png";
import hangout from "../images/google-hangouts.png";
import zoom from "../images/icons8-zoom-50.png";
import microsoftTeam from "../images/icon-teams.svg";

import MeetPaulIllu from "../images/Meet Paul illu.png";
import marc from "../images/marc-laurant.jpeg";
import ben from "../images/ben-marrel.jpeg";
import julius from "../images/julius-geis.png"


const IndexPage = ({intl}) => (
    <React.Fragment>
      <SEO title={intl.formatMessage({id: "home.metadata.title"})} description={intl.formatMessage({id: "home.metadata.description"})} />
      <SEO meta={{name: 'facebook-domain-verification', content: "qviaz6ohrljlfb5qrmakib535721go"}} />
      <div className="margintop118" />
      <section className="my-5">
        <div className="container">
          <div className="row julie-banner">
            <div className="col-md-6 julie-banner-left-header">
              <h1>JulieDesk, <span>{intl.formatMessage({id: "your"})}</span> <br /> <span>{intl.formatMessage({id: "virtual_assistant_team"})}</span><br /></h1>
              <p></p>
              <p>
                  {intl.formatMessage({id: "julieDesks_services_content_1"})}
              </p>
              <p>
                  {intl.formatMessage({id: "julieDesks_services_content_2"})}
              </p>
              <div className="top35">
                <div className="row">
                  <div className="col-md-5">
                    <a target="_blank" rel="noreferrer" href={process.env.GATSBY_CALENDLY_LINK} className="mainBtn mixBackground">
                      <span>{intl.formatMessage({ id: "contact_us" })}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 julie-banner-right-content">
              <img src={illu} className="img-fluid" />
            </div>
          </div>
        </div>
      </section>
      <Community />
      <section className="my-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h6 className="whatWedo">{intl.formatMessage({id: "what_we_do"})}</h6>
              <h1 className="ourServices"><span className="textBrown">{intl.formatMessage({id: "our"})}</span> <span className="textPurpel">{intl.formatMessage({id: "services"})}</span></h1>
            </div>
          </div>
          <div className="row">
            <div className="col-md-2 text-center d-none d-md-block">
              <img src={dotshape} alt="DotShape" className="dots" />
            </div>
            <div className="col-md-4 serviceslistsMain ">
              <div className="card-head card-service ml-n3" />
              <div className="card-body">
                <img src={icon} />
                <h5 className="font-weight-bold mt-3 mb-4 cmpa">{intl.formatMessage({id: "community_management"})}</h5>
                <div className="row serviceslists" style={{marginBottom: '5px'}}>
                  <div className="col-md-1"><img src={checkmarkCircle2} /></div>
                  <div className="col-md-10"><p>{intl.formatMessage({id: "managing_your_communication"})}</p></div>
                </div>
                <div className="row serviceslists" style={{marginBottom: '5px'}}>
                  <div className="col-md-1"><img src={checkmarkCircle2}/></div>
                  <div className="col-md-10"><p>{intl.formatMessage({id: "increase_the_local"})}</p></div>
                </div>
                <div className="row serviceslists" style={{marginBottom: '115px'}}>
                  <div className="col-md-1"><img src={checkmarkCircle2} /></div>
                  <div className="col-md-10"><p>{intl.formatMessage({id: "exclusive_publications"})}</p></div>
                </div>
                <div className="d-flex m-lg-3 to-bottom">
                  <Link to="/paul" className="package-button"  href="#"><span>{intl.formatMessage({id: "see_more"})}</span></Link>
                </div>
              </div>
            </div>
            <div className="col-md-4 serviceslistsMain ">
              <div className="card-head card-service mr-n3" />
              <div className="card-body">
                <img src={socialMediaMarketing} />
                <h5 className="font-weight-bold mt-3 mb-4 cmpa">{intl.formatMessage({id: "pa_Services"})}</h5>
                <div className="row serviceslists" style={{marginBottom: '5px'}}>
                  <div className="col-md-1"><img src={checkmarkCircle2} /></div>
                  <div className="col-md-10"><p>{intl.formatMessage({id: "24_7_Services"})}</p></div>
                </div>
                <div className="row serviceslists" style={{marginBottom: '5px'}}>
                  <div className="col-md-1"><img src={checkmarkCircle2} /></div>
                  <div className="col-md-10"><p>{intl.formatMessage({id: "meeting_management"})}</p></div>
                </div>
                <div className="row serviceslists" style={{marginBottom: '115px'}}>
                  <div className="col-md-1"><img src={checkmarkCircle2} /></div>
                  <div className="col-md-10"><p>{intl.formatMessage({id: "3_offers_teddy_violetta"})}<br /></p></div>
                </div>
                <div className="d-flex m-lg-3 to-bottom">
                  <Link to="/pricing" className="package-button"  href="#"><span>{intl.formatMessage({id: "see_more"})}</span></Link>
                </div>
              </div>
            </div>
            <div className="col-md-2 text-center d-none d-md-block">
              <img src={dotshape} alt="DotShape" className="dots" />
            </div>
          </div>
        </div>
      </section>
      <section className="my-5">
        <div className="container">
          <div className="row margingTop152">
            <div className="col-md-12">
              <h6 className="whatWedo">{intl.formatMessage({id: "our_team"})}</h6>
              <h1 className="ourServices"><span className="textBrown">{intl.formatMessage({id: "do_you_need_a"})} </span> <br/> <span className="textPurpel">{intl.formatMessage({id: "personal_assistant"})}</span><br/><span className="textPurpel">{intl.formatMessage({id: "personal_assistant_emailing"})}</span></h1>
            </div>
          </div>
          <div className="row julie-banner personalAssistant">
            <div className="col-md-6 personalAssistantLeft">
              <img src={IlluPersonnalAssistant} />
            </div>
            <div className="col-md-6 personalAssistantRight">
              <h1>
                Teddy, Violetta &amp; Julie
              </h1>
              <h6>{intl.formatMessage({id: "pa_team"})}</h6>
              <p>
                <span> {intl.formatMessage({id: "our_fantastic_pa_team"})}</span>
              </p>
              <div className="imgs">
                <img src={googleCalendar} />
                <img src={office} />
                <img src={exchange} />
                <img src={gmail} />
                <img src={hangout} />
                <img src={zoom} />
                <img src={microsoftTeam} />
              </div>
              <div className="d-flex btnCenter top35">
                <Link className="package-button hoverVoliet" to="/pricing"><span>{intl.formatMessage({id: "learn_more"})}</span></Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="my-5">
        <div className="container">
          <div className="row margingTop152">
            <div className="col-md-12">
              <h6 className="whatWedo">{intl.formatMessage({id: "our_team"})}</h6>
              <h1 className="ourServices"><span className="textBrown">{intl.formatMessage({id: "do_you_need_a"})} </span><br/><span className="textPurpel">{intl.formatMessage({id: "community_manager"})}?</span></h1>
            </div>
          </div>
          <div className="row communityManager">
            <div className="col-md-6 communityManagerRight mobCmShow">
              <img src={MeetPaulIllu} />
            </div>
            <div className="col-md-6 communityManagerLeft">
              <h1>
                Paul
              </h1>
              <h6 className="text-uppercase">{intl.formatMessage({id: "community_manager"})}</h6>
              <p className="julie-head-desc">
                  {intl.formatMessage({id: "paul_and_his_team"})}
              </p>
              <div className="imgs">
                <img src={gmail} />
                <img src={hangout} />
                <img src={zoom} />
              </div>
              <div className="d-flex btnCenter top35">
                <Link className="cm-button" to="/paul"><span>{intl.formatMessage({id: "learn_more"})}</span></Link>
              </div>
            </div>
            <div className="col-md-6 communityManagerRight mobCmHide">
              <img src={MeetPaulIllu} />
            </div>
          </div>
        </div>
      </section>
      <div className="testimonials">
        <div className="container">
          <div className="row margingTop152">
            <div className="col-md-12" style={{marginTop: '134px'}}>
              <h6 className="whatWedo text-uppercase">{intl.formatMessage({id: "testimonials"})}</h6>
              <h1 className="feeback"><span className="textBrown">{intl.formatMessage({id: "clients"})}</span> <span className="textPurpel">{intl.formatMessage({id: "feeback"})}</span></h1>
            </div>
          </div>
          <div id="carouselFeed" className="carousel slide" data-ride="carousel">
            <div className="carousel-inner">
              <div className="carousel-item active">
                <div className="carousel-caption">
                  <p>«&nbsp;  {intl.formatMessage({id: "julie_helps_me"})}&nbsp;»</p>
                  <div className="row">
                    <div className="col-md-2">
                      <img src={julius} />
                    </div>
                    <div className="col-md-10">
                      <p className="founderText">Julius Geis</p>
                      <p className="foundationText">Founder of On Any Given Monday</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="carousel-item">
                <div className="carousel-caption">
                  <p>«&nbsp;{intl.formatMessage({id: "for_all_those"})} &nbsp;»</p>
                  <div className="row">
                    <div className="col-md-2">
                      <img src={marc} className="img-fluid" />
                    </div>
                    <div className="col-md-10">
                      <p className="founderText">Marc Laurent</p>
                      <p className="foundationText">Founder of Kerala VC</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="carousel-item">
                <div className="carousel-caption">
                  <p>«&nbsp;{intl.formatMessage({id: "a_real_time_saving"})}&nbsp;»</p>
                  <div className="row">
                    <div className="col-md-2">
                      <img src={ben} className="img-fluid" />
                    </div>
                    <div className="col-md-10">
                      <p className="founderText">Ben Marrel</p>
                      <p className="foundationText">{intl.formatMessage({id: "founder_of_breega"})}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ol className="carousel-indicators">
              <li data-target="#carouselFeed" data-slide-to={0} className="active" />
              <li data-target="#carouselFeed" data-slide-to={1} />
              <li data-target="#carouselFeed" data-slide-to={2} />
            </ol>
          </div>
        </div>
      </div>
        {/* Footer */}
      <hr className="hrdown" />
      <div data-include="footer" />
    </React.Fragment>
)

export default compose(
    withPageContext,
    injectIntl,
    withLayout,
)(IndexPage);
